import React from "react";
import MuiPagination from "@mui/material/Pagination";

export const Pagination = (props) => {

    const { currentPage, maxPage, setCurrentPage } = props;

    return (
        <div className="pagination">
            <MuiPagination
                size="large"
                page={currentPage + 1}
                count={maxPage || 1}
                onChange={(event, page) => setCurrentPage(page - 1)}
                sx={{
                    "& .MuiPaginationItem-root": {
                        fontSize: "16px",
                        minWidth: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    },
                }}
            />
        </div>
    );
};
